<template>
  <div class="container">
    <div v-if="removedRecupHoliday != null || removedRecupHoliday != undefined" class="alert alert-warning" role="alert">
      Onvoldoende recup feestdag beschikbaar. De ingeplande recup feestdag op {{removedRecupHoliday}} werd verwijderd.
    </div>
    <div class="row justify-content-center">
      <h3>Overzicht
        Shiften{{ ownerOfShifts ? ' van ' + ownerOfShifts.firstName + ' ' + ownerOfShifts.lastName : '' }}</h3>
    </div>
    <div class="row justify-content-between">
      <div class="col-md-4 col-sm-12">
        <MonthSelectComponent/>
      </div>
      <template v-if="!completed">
        <div class="col-md-4 col-sm-12" v-if="showCreateShift">
          <button class="btn-basic btn-fill-pulse-dark" @click="toggleCreateShift()">Annuleren</button>
        </div>
        <div class="col-md-4 col-sm-12" v-else>
          <button class="btn-basic btn-fill-pulse" @click="toggleCreateShift()">Toevoegen</button>
        </div>
      </template>
    </div>
    <div
        class="alert alert-warning" role="alert"
        v-if="completed">
      TimeSheet is bevestigd. Je kan hier geen aanpassingen meer doen
    </div>
    <div class="row" v-show="showCreateShift">
      <CreateWorkedShift id="createShift" @shiftAdded="toggleCreateShift"/>
    </div>
    <div>
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead class="thead-dark">
          <tr>
            <SortableTableHeaderComponent
                columnName="customerName" :sortColumn="currentSortColumn"
                :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
                text="Klant"/>
            <SortableTableHeaderComponent
                columnName="title" :sortColumn="currentSortColumn"
                :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
                text="Shift type"/>
            <SortableTableHeaderComponent
                columnName="date" :sortColumn="currentSortColumn"
                :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
                text="Datum"/>
            <SortableTableHeaderComponent
                columnName="hours" :sortColumn="currentSortColumn"
                :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
                text="Gewerkte uren"/>
          </tr>
          </thead>
          <template v-for="row in sortedRows">
            <TableRow :rowObject="row" :key="row.date + row.title"/>
          </template>
        </table>
      </div>
      <div>
        <modal id="download">
          <div slot="title">
            <h4>Kies je klant</h4>
          </div>
          <div slot="body">
            <div class="row justify-content-between p-3">
              <div v-for="contract in activeContracts" :key="contract.id">
                <button
                    v-if="isDownloading" class="btn btn-dark"
                    disabled>
                  Downloading
                </button>
                <button
                    :disabled='!completed'
                    v-else class="btn btn-dark"
                    @click="downloadPdf(contract.id)">{{ contract.customerName }}
                </button>
              </div>
            </div>
          </div>
        </modal>
      </div>
      <div class="row">
        <button
            :disabled="completed" class="btn-basic btn-fill-pulse mr-2"
            v-on:click="handleConfirm">Bevestig Timesheet</button>
        <button
            v-if="isDownloading" class="btn-basic btn-big btn-dark"
            disabled> Downloading
        </button>
        <button
            :disabled='!completed'
            v-else class="btn-basic btn-big btn-outline-pulse-dark"
            @click="handleDownload"> Download PDF
        </button>
      </div>
    </div>
  </div>

</template>

<script>
import TableRow from "../components/WorkedShiftDetailTab/TableRow";
import {mapActions, mapGetters} from "vuex";
import MonthSelectComponent from "../components/MonthSelectComponent/MonthSelectComponent";
import CreateWorkedShift from "../components/EditDetailsComponent/CreateWorkedShift";
import {Modal, VoerroModal} from '@voerro/vue-modal';
import {toYearAndMonth} from "@/util/DateUtil";
import * as moment from "moment";
import {sortListByColumnAndDirection} from "@/util/SortingUtil";
import SortableTableHeaderComponent from "@/components/tables/SortableTableHeader";

export default {
  name: "EditDetails",
  components: {
    SortableTableHeaderComponent,
    TableRow,
    MonthSelectComponent,
    CreateWorkedShift,
    Modal
  },
  data: () => ({
    showCreateShift: false,
    isDownloading: false,
    currentSortColumn: "date",
    currentSortDirectionAscending: true,
  }),
  computed: {
    ...mapGetters({
      workShifts: "timesheet/workShifts",
      absenceDays: "timesheet/absenceDays",
      selectedUser: "user/currentLoggedInUser",
      completed: 'timesheet/completed',
      activeContracts: 'timesheet/activeContracts',
      removedRecupHoliday: 'timesheet/removedRecupHoliday',
      currentlySelectedMonth: 'time/currentlySelectedMonth'
    }),
    //TODO: fetch userId of owner of timesheet depending on selected contract. for now the logged in user is being shown
    ownerOfShifts: function () {
      if (this.workShifts?.length > 0) {
        return this.selectedUser;
      }
      return null;
    },
    sortedRows: function () {
      const workShifts = this.getWorkedShiftsWithIdInDay();
      const absenceDays = this.getAbsenceDays();
      const rows = [...workShifts, ...absenceDays];

      if (this.currentSortColumn === "date") {
        return sortListByColumnAndDirection(rows, this.currentSortColumn, this.currentSortDirectionAscending, this.dateToMillis);
      }
      return sortListByColumnAndDirection(rows, this.currentSortColumn, this.currentSortDirectionAscending);
    },
  },
  async created() {
    await this.getAllActiveContractsAndPickSelected();
    await this.fetchWorkShifts();
    await this.fetchAbsences();
  },
  methods: {
    ...mapActions("timesheet", ['completeTimeSheet', "fetchWorkShifts", "fetchAbsences", 'getAllActiveContractsAndPickSelected', 'downloadTimeSheet']),
    getWorkedShiftsWithIdInDay() {
      const workedShifts = this.workShifts.map(workShift => ({
        type: 'workShift',
        customerName: workShift.customerName,
        title: workShift.title,
        date: moment(workShift.labourPeriod.startDateTimestamp),
        hours: workShift.workedHours,
        color: workShift.color,
        textColor: workShift.textColor,
        shift: workShift,
        editedByAdmin: workShift.editedByAdmin
      }));

      const ascending = true;
      const workShiftsSortedByDate = sortListByColumnAndDirection(workedShifts, "date", ascending, this.dateToMillis);

      workShiftsSortedByDate.forEach(shiftRow => {
        shiftRow.idInDayForCustomer = this.getIdInDayForCustomer(shiftRow, workShiftsSortedByDate);
      });
      return workShiftsSortedByDate;
    },
    getAbsenceDays() {
      return this.absenceDays.map(absence => ({
        type: 'absence',
        customerName: '',
        title: absence.title,
        date: moment(absence.start),
        hours: absence.hours,
        color: absence.color,
        textColor: absence.textColor,
        shift: absence,
        editedByAdmin: absence.editedByAdmin
      }));
    },
    getIdInDayForCustomer(rowObject, orderedShiftsByDate) {
      const currentDay = rowObject.date;

      const shiftsInSameDayAndSameCustomer = orderedShiftsByDate
          .filter(row => this.isSameDay(row.date, currentDay))
          .filter(row => row.shift.customerName === rowObject.shift.customerName);
      return shiftsInSameDayAndSameCustomer.indexOf(rowObject);
    },
    handleConfirm() {
      if (confirm('Ben je zeker dat je de timesheet wilt bevestigen? Hierna kan je niets meer aanpassen.')) {
        const yearMonth = toYearAndMonth(this.currentlySelectedMonth);
        this.completeTimeSheet(yearMonth);
      }
    },
    toggleCreateShift() {
      this.showCreateShift = !this.showCreateShift;
    },
    handleDownload() {
      if (this.activeContracts.length > 1) {
        VoerroModal.show("download");
      } else if (this.activeContracts.length === 1) {
        this.downloadPdf(this.activeContracts[0].id);
      }
    },
    downloadPdf(id) {
      this.isDownloading = true;
      this.downloadTimeSheet(id)
          .then(() => this.isDownloading = false)
          .catch(() => this.isDownloading = false);
    },
    isSameDay(date1, date2) {
      return date1.isSame(date2, 'day');
    },
    dateToMillis(date) {
      return moment(date).valueOf();
    },
    sort: function (newSortColumn) {
      if (newSortColumn === this.currentSortColumn) {
        this.currentSortDirectionAscending = !this.currentSortDirectionAscending;
      } else {
        this.currentSortDirectionAscending = true;
      }
      this.currentSortColumn = newSortColumn;
    }
  }
};
</script>
<style scoped>
  .btn-big {
    height: 65px;
  }
</style>